import FirebaseApi from './firebase-api';
import { APP_STATE_ACTION_TYPE_USER } from '../state/seed-states';
import SeedAuthenticationRepository from '../repository/SeedAuthenticationRepository';

class FirebaseRepository extends SeedAuthenticationRepository {
  constructor(state, dispatch, firebaseConfig) {
    super(state, dispatch);
    this.firebaseApi = new FirebaseApi(firebaseConfig, state);
  }

  verifyEmail() {
    return this.firebaseApi.verifyEmail();
  }

  linkProvider(provider) {
    return this.firebaseApi.linkProvider(provider);
  }

  unlinkProvider(provider) {
    return this.firebaseApi.unlinkProvider(provider);
  }

  signInProvider(provider) {
    return this.firebaseApi.signInProvider(provider);
  }

  signInPhoneNumber(data, appVerifier) {
    return this.firebaseApi.signInPhoneNumber(data.phoneNumber, appVerifier);
  }

  confirmSMSCode(confirmationResult, data) {
    return this.firebaseApi.confirmSMSCode(confirmationResult, data.code);
  }

  deleteUser(data) {
    return this.firebaseApi.deleteUser(data);
  }

  registerEmailPassword(data) {
    return this.firebaseApi.registerEmailPassword(data.email, data.password);
  }

  registerEmailLink(data) {
    return this.firebaseApi.registerEmailLink(data.email);
  }

  loginEmailPassword(data) {
    return this.firebaseApi.loginEmailPassword(data.email, data.password, data.rememberMe);
  }

  loginEmailLink(data) {
    return this.firebaseApi.loginEmailLink(data.email, data.link);
  }

  loginGoogle() {
    return this.firebaseApi.loginGoogle();
  }

  loginFacebook() {
    return this.firebaseApi.loginFacebook();
  }

  // override
  logout() {
    return this.firebaseApi.logout();
  }

  logoutUser() {
    return super.logout();
  }

  updatePassword(data) {
    return this.firebaseApi.updatePassword(data.oldPassword, data.password);
  }

  updatePasswordPopup(data) {
    return this.firebaseApi.updatePasswordPopup(data.password);
  }

  updateEmail(data) {
    return this.firebaseApi.updateEmail(data.password, data.email);
  }

  sendPasswordResetEmail(data) {
    return this.firebaseApi.sendPasswordResetEmail(data.email);
  }

  updateEmailWithProvider(data) {
    return this.firebaseApi.updateEmailWithProvider(data.email);
  }

  updateProfile(data) {
    return this.firebaseApi.updateProfile(data);
  }

  updateProfilePhoto(values) {
    return this.firebaseApi.updateProfilePhoto(values.photoURL);
  }

  removeProfilePhoto() {
    return this.firebaseApi.removeProfilePhoto();
  }

  // override
  isAuthenticated() {
    const currentUser = this.state[APP_STATE_ACTION_TYPE_USER];
    if (currentUser) {
      return true;
    }
    // If user is falsy, return false.
    return false;
  }

  // override
  // eslint-disable-next-line class-methods-use-this
  saveUser(firebaseUser) {
    const providers = [];
    firebaseUser.providerData.forEach((provider) => {
      providers.push(provider);
    });
    // User is signed in.
    const user = {
      uid: firebaseUser.uid,
      displayName: firebaseUser.displayName,
      photoURL: firebaseUser.photoURL,
      email: firebaseUser.email,
      emailVerified: firebaseUser.emailVerified,
      phoneNumber: firebaseUser.phoneNumber,
      isAnonymous: firebaseUser.isAnonymous,
      lastSignInTime: firebaseUser.metadata.lastSignInTime,
      creationTime: firebaseUser.metadata.creationTime,
      providers,
    };
    let title = user.displayName;
    if (!title) {
      title = user.email;
      if (!title) {
        title = user.phoneNumber;
      }
    }
    let subtitle = user.email;
    if (!subtitle) {
      subtitle = user.phoneNumber;
    }
    this.dispatch({
      type: APP_STATE_ACTION_TYPE_USER,
      value: {
        user,
        avatar: {
          avatar: user.photoURL,
          title,
          subtitle,
        },
      },
      valueType: 'json',
    });
  }
}

export default FirebaseRepository;
